module.exports = __webpack_public_path__ + "img/accessor-sq.bb384278.svg";